import { onBeforeUnmount } from "vue";

export const useHead = () => {
  let removeBodyColor: () => void;

  const setBodyColor = (color: string) => {
    document.documentElement.style.setProperty('--site-bg', color);

    removeBodyColor = () => {
      document.documentElement.style.removeProperty('--site-bg');
    }
  }

  // onBeforeUnmount(() => {
  //   if (removeBodyColor) removeBodyColor()
  // });

  return {
    setBodyColor,
  }
} 